import axios from 'axios'
import config from '@/config'
import store from '@/store/index'
import LoginLogout from './LoginLogout'
import { __replaceDotCom } from '@/utils/tools'
import { cloneDeep } from 'lodash'
const gatewayCfg = config.gateway

export const cryptoRand = () => {
    const randomBuffer = new Uint32Array(1)
    window.crypto.getRandomValues(randomBuffer)
    return randomBuffer[0] / (0xffffffff + 1)
}
const getRequestUrl = function(config, onlyUrl) {
    let url = config.url
    // 非本域直接返回
    if (!url) { return '' }
    if (url.indexOf('://') > -1 || url.indexOf('//') === 0) {
        return url
    }
    const getTraceId = function getTraceId() {
        var s = []
        var hexDigits = '0123456789abcdef'
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(cryptoRand() * 0x10), 1)
        }
        // bits 12-15 of the time_hi_and_version field to 0010
        s[14] = '4'
        // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1)
        s[8] = s[13] = s[18] = s[23] = '-'

        return s.join('')
    }
    const services = gatewayCfg.services
    const keys = Object.keys(services).sort((a, b) => a.length < b.length)
    for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        if (url.match(new RegExp(`^${key}`))) {
            let urlConfig = services[key]
            let gateway = __replaceDotCom(gatewayCfg.MsaGatewayAddress, true)
            let appId = urlConfig['x-app-id']
            let subappId = urlConfig['x-sub-app-id']
            let separator = urlConfig['x-url-separator'] || ':'
            let context = urlConfig['context'] || '/'
            url = `${gateway}${appId}${separator}${subappId}${context}${url}`
            break
        }
    }
    onlyUrl || (config.headers.traceId = getTraceId())
    return url
}

/**
 * 从query参数中获取访问地址里面的展会ID的值
 * 用于请求在header增加展会ID入参
 */
const filterQueryParam = () => {
    let exhiId = ''
    let queryObj = {}
    let queryParam = window.location.hash.split('?')
    if (queryParam[1]) {
        queryParam = queryParam[1].split('&')
        queryParam.forEach((item) => {
            let itemParam = item.split('=')
            queryObj[itemParam[0]] = itemParam[1]
        })
    }
    if (queryObj['exhiId']) {
        exhiId = queryObj['exhiId']
    }
    return exhiId
}

/**
 * 如果有操作，刷新请求刷新本地SSO的时效
 * 主要作用解决一直在访问也会超时的问题
 */
let ssoTimer = null
const ssoTimeUpdate = function() {
    // 刷新SSO API接口
    const url = 'eventsgo/media/services/only4ssoTimeUpdate.do'
    // 延长SSO操作，每隔5分钟执行一次
    let nowTime = new Date().getTime()
    let calcSpaced = ssoTimer ? nowTime - ssoTimer : 0
    let spaced = 3 * 60 * 1000
    if (ssoTimer && calcSpaced > spaced) {
        let gatewayUrl = getRequestUrl({ url: url }, true)
        service.get(gatewayUrl)
        // 刷新记录时间戳
        ssoTimer = nowTime
    } else if (!ssoTimer) {
        // 初次访问记录时间戳
        ssoTimer = nowTime
    }
}

// create an axios instance
const service = axios.create({
    baseURL: config.baseURL, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 100000, // request timeout,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

// request interceptor
service.interceptors.request.use(
    config => {
        ssoTimeUpdate()

        /**
         * 权限跟展会有关，在请求的时候，所有请求接口新增header入参，将展会ID传给后端
         * 游客（Tourists0）散客（Casual）客户经理（Guest） 不需要 展会ID的入参 verificationRole() 方法里面做这个事情
         * filterRouterParam() 方法获取地址栏的展会ID
         * 因为web/support/workspace/current 获取角色权限的时候需要基于展会ID，所有只能从地址栏里面获取
         */
        let configExhiId = config.data && config.data.exhiId ? config.data.exhiId + '' : ''
        // 如果请求参数里面带有 exhiId 取参数里面的展会ID，没有的情况下取地址的query参数展会ID，都没有不做处理
        let queryExhiId = filterQueryParam() || configExhiId
        // /jalor/security/user/这类接口header入参不传递展会ID，如果传递多租户鉴权引起接口报错500 2019-07-18
        if (config.url && config.url.endsWith('/current') && queryExhiId) {
            config.headers['eventsgo-ext-info'] = JSON.stringify({ exhiId: queryExhiId })
        }
        // 添加展会ID
        if (queryExhiId) {
            let tempParams = cloneDeep(config.params) || {}
            if (!tempParams.exhiId) { tempParams.exhiId = queryExhiId }
            config.params = tempParams

            // 针对于post、put等
            if (config.method !== 'get' && ['[object Array]', '[object Object]'].includes(Object.prototype.toString.call(config.data))) {
                let tempDatas = cloneDeep(config.data) || {}
                if (Array.isArray(tempDatas)) {
                    for (let item of tempDatas) {
                        if (Object.prototype.toString.call(item) === '[object Object]') {
                            if (!item.exhiId) { item.exhiId = queryExhiId }
                        }
                    }
                } else {
                    if (!tempDatas.exhiId) { tempDatas.exhiId = queryExhiId }
                }
                config.data = tempDatas
            }
        }
        // add header exhiId end
        // 2020/10/31在headers中添加jalorSecurityToken
        const jalorSecurityToken = store.state.common.env.jalorSecurityToken
        const xScarfToken = store.state.common.header['x-csrf-token']
        config.headers['x-csrf-token'] = xScarfToken || jalorSecurityToken || ''
        config.url = getRequestUrl(config)
        if (config.method === 'get' && !config.url.endsWith('/current')) {
            let params = { _time: Date.now(), language: store.state.common.lang }
            config.params = { ...params, ...config.params }
        }
        if (config.url.includes('eventsgo/common')) {
            let params = {
                "x-app-id": 'com.huawei.mbs.cims.eventsgovehicle',
                "x-sub-app-id": 'eventsgovehicle'
            }
            config.params = { ...params, ...config.params }
        } else if (config.url.includes('public/lookupService/list')) {
            let params = {
                "appName": 'eventsgocommon'
            }
            config.params = { ...config.params, ...params }
        }
        // 特殊参数，用于uniportal
        config.params = { ...config.params, "/saaslogin/idp/pname": 'eventsgo-pend' }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data

        /**
         * 登录超时，注销跳转登录页面的逻辑处理
         * 登录超时或注销，接口会返回 标识
         */
        if (res.errorCode === 'huawei.jalor5.security.00010002' && res.httpCode === 403) {
            LoginLogout.login()
        }
        if (response.status !== 200) {
            return Promise.reject(msg)
        } else {
            return response
        }
    },
    error => {
        return Promise.reject(error)
    }
)

export default service
export { getRequestUrl }
